/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { Icon } from './Icon';

export namespace SettingsIcon {
  export interface Props extends Icon.Props {}
}

export const SettingsIcon: React.FC<Icon.Props> = ({ fill = 'none', stroke = undefined, size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={fill}
    stroke={stroke}
    focusable="false"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M19.1372 12.9344C19.1732 12.6344 19.1972 12.3224 19.1972 11.9984C19.1972 11.6744 19.1732 11.3624 19.1252 11.0624L21.1532 9.47844C21.3332 9.33444 21.3812 9.07044 21.2732 8.86644L19.3532 5.54244C19.2332 5.32644 18.9812 5.25444 18.7652 5.32644L16.3772 6.28644C15.8732 5.90244 15.3452 5.59044 14.7572 5.35044L14.3972 2.80644C14.3612 2.56644 14.1572 2.39844 13.9172 2.39844H10.0772C9.83718 2.39844 9.64518 2.56644 9.60918 2.80644L9.24918 5.35044C8.66118 5.59044 8.12118 5.91444 7.62918 6.28644L5.24118 5.32644C5.02518 5.24244 4.77318 5.32644 4.65318 5.54244L2.73318 8.86644C2.61318 9.08244 2.66118 9.33444 2.85318 9.47844L4.88118 11.0624C4.83318 11.3624 4.79718 11.6864 4.79718 11.9984C4.79718 12.3104 4.82118 12.6344 4.86918 12.9344L2.84118 14.5184C2.66118 14.6624 2.61318 14.9264 2.72118 15.1304L4.64118 18.4544C4.76118 18.6704 5.01318 18.7424 5.22918 18.6704L7.61718 17.7104C8.12118 18.0944 8.64918 18.4064 9.23718 18.6464L9.59718 21.1904C9.64518 21.4304 9.83718 21.5984 10.0772 21.5984H13.9172C14.1572 21.5984 14.3612 21.4304 14.3852 21.1904L14.7452 18.6464C15.3332 18.4064 15.8732 18.0824 16.3652 17.7104L18.7532 18.6704C18.9692 18.7544 19.2212 18.6704 19.3412 18.4544L21.2612 15.1304C21.3812 14.9144 21.3332 14.6624 21.1412 14.5184L19.1372 12.9344V12.9344ZM11.9972 15.5984C10.0172 15.5984 8.39718 13.9784 8.39718 11.9984C8.39718 10.0184 10.0172 8.39844 11.9972 8.39844C13.9772 8.39844 15.5972 10.0184 15.5972 11.9984C15.5972 13.9784 13.9772 15.5984 11.9972 15.5984Z" />
  </svg>
);
